import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Bell } from "lucide-react";

export const NotificationBell = () => {
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const navigate = useNavigate();
  const load = () => api.get("/notifications").then((r) => { setItems(r.data.items); setUnread(r.data.unread); }).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);
  const markOne = async (n) => {
    if (!n.read) await api.post(`/notifications/${n.id}/read`).catch(() => {});
    if (n.customer_id) navigate(`/app/customers/${n.customer_id}`);
    else { load(); navigate("/app/notifications"); }
  };
  return (
    <Popover onOpenChange={(o) => { if (o) load(); }}>
      <PopoverTrigger asChild>
        <Button variant="outline" size="icon" className="relative" data-testid="notif-bell">
          <Bell size={18} />
          {unread > 0 && (
            <span className="absolute -top-1.5 -right-1.5 bg-rose-500 text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1" data-testid="notif-count">{unread}</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0">
        <div className="px-4 py-3 border-b font-semibold text-sm text-slate-700">Notifications</div>
        <div className="max-h-80 overflow-y-auto">
          {items.length === 0 ? (
            <div className="p-6 text-center text-sm text-slate-400">No notifications yet.</div>
          ) : items.slice(0, 8).map((n) => (
            <button key={n.id} onClick={() => markOne(n)} className={`w-full text-left px-4 py-3 border-b last:border-0 hover:bg-slate-50 transition-colors ${n.read ? "" : "bg-blue-50/60"}`} data-testid="notif-item">
              <div className="text-sm text-slate-800">{n.message}</div>
              <div className="text-xs text-slate-400 mt-0.5">{new Date(n.created_at).toLocaleString()}</div>
            </button>
          ))}
        </div>
        <button
          onClick={() => navigate("/app/notifications")}
          data-testid="notif-view-all"
          className="w-full px-4 py-2.5 text-sm font-medium text-blue-600 hover:bg-blue-50 border-t transition-colors"
        >
          View all notifications
        </button>
      </PopoverContent>
    </Popover>
  );
};
